/**
 * Represents the type of the email
 *
 * this value is NotificationType from "feathers-authentication-management";
 *
 * 'resendVerifySignup' | 'verifySignup' | 'verifySignupSetPassword' | 'sendResetPwd' | 'resetPwd' | 'passwordChange' | 'identityChange'
 */
export const enum EmailType {
  RESEND_VERIFY_SIGNUP = 'resendVerifySignup',
  VERIFY_SIGNUP = 'verifySignup',
  VERIFY_SIGNUP_SET_PASSWORD = 'verifySignupSetPassword',
  SEND_RESET_PASSWORD = 'sendResetPwd', // old value: sendResetPassword
  REST_PASSWORD = 'resetPwd',
  CHANGE_PASSWORD = 'passwordChange',
  CHANGE_IDENTITY = 'identityChange',
  PAYMENT_SUCCESS = 'paymentSuccess',
  VERIFY_TWO_FACTOR_AUTHENTICATION = 'verifyTwoFactorAuthentication',
}
